module.exports = __webpack_public_path__ + "assets/img/right-0d7008b1.png";